import { dynamicGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import { segmentSchema } from "@redotech/redo-model/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const createDynamicSegment = {
  name: "createDynamicSegment" as const,
  description:
    "Create a dynamic (auto-updating) audience from a set of conditions. Typically followed by createCampaign to target the new segment. Check fetchTeamSegments first to reuse an existing audience instead of duplicating one.",
  mutates: true,
  input: z.object({ name: z.string(), conditions: segmentSchema }),
  output: dynamicGroupSchema,
};
